export const NavigationEvent = (navParams) => ({
  type: 'NAVIGATION',
  ...navParams,
});

export const UserRegisteredEvent = (userId, code) => ({
  type: 'USER_REGISTERED',
  userId,
  code,
});

export const EmailVerifiedEvent = (userId) => ({
  type: 'EMAIL_VERIFIED',
  userId,
});

export const UserLoggedInEvent = (userId) => ({
  type: 'USER_LOGGED_IN',
  userId,
});

export const UserLoggedOutEvent = () => ({
  type: 'USER_LOGGED_OUT',
});

export const CodeSubmittedEvent = (code) => ({
  type: 'CODE_SUBMITTED',
  code,
});

export const LandingOfferClickedEvent = (merchantId) => ({
  type: 'LANDING_OFFER_CLICKED',
  merchantId,
});

export const ClusterExpiredEvent = (clusterId) => ({
  type: 'CLUSTER_EXPIRED',
  clusterId,
});

export const ClusterExpiredIosStoreClickedEvent = (clusterId) => ({
  type: 'CLUSTER_EXPIRED_IOS_STORE_CLICKED',
  clusterId,
});

export const ClusterExpiredAndroidStoreClickedEvent = (clusterId) => ({
  type: 'CLUSTER_EXPIRED_ANDROID_STORE_CLICKED',
  clusterId,
});

export const LandingIosStoreClickedEvent = (clusterId) => ({
  type: 'LANDING_IOS_STORE_CLICKED',
  clusterId,
});

export const LandingAndroidStoreClickedEvent = (clusterId) => ({
  type: 'LANDING_ANDROID_STORE_CLICKED',
  clusterId,
});

export const TimeLimitModalClicked = (clusterId) => ({
  type: 'TIME_LIMIT_MODAL_CLICKED',
  clusterId,
});

export const LandingOmaKotiSignUpExternalUrlClicked = (clusterId) => ({
  type: 'LANDING_OMAKOTI_SIGNUP_EXTERNAL_URL_CLICKED',
  clusterId,
});

// Offer events
export const OfferShopInStoreIosStoreClickedEvent = (
  clusterId,
  merchantId,
  offerId,
  seasonCampaignId,
) => ({
  type: 'OFFER_SHOP_IN_STORE_IOS_STORE_CLICKED',
  clusterId,
  merchantId,
  offerId,
  seasonCampaignId,
});

export const OfferShopInStoreAndroidStoreClickedEvent = (
  clusterId,
  merchantId,
  offerId,
  seasonCampaignId,
) => ({
  type: 'OFFER_SHOP_IN_STORE_ANDROID_STORE_CLICKED',
  clusterId,
  merchantId,
  offerId,
  seasonCampaignId,
});

export const OfferShopInStorePopupOpenedEvent = (
  merchantId,
  offerId,
  seasonCampaignId,
) => ({
  type: 'OFFER_SHOP_IN_STORE_POPUP_OPENED',
  merchantId,
  offerId,
  seasonCampaignId,
});

export const OfferShopOnlinePopupOpenedEvent = (
  merchantId,
  offerId,
  seasonCampaignId,
) => ({
  type: 'OFFER_SHOP_ONLINE_POPUP_OPENED',
  merchantId,
  offerId,
  seasonCampaignId,
});

export const OfferShopOnlineClickedEvent = (
  merchantId,
  offerId,
  seasonCampaignId,
) => ({
  type: 'OFFER_SHOP_ONLINE_CLICKED',
  merchantId,
  offerId,
  seasonCampaignId,
});

export const OfferCallUsPopupOpenedEvent = (
  merchantId,
  offerId,
  seasonCampaignId,
) => ({
  type: 'OFFER_CALL_US_POPUP_OPENED',
  merchantId,
  offerId,
  seasonCampaignId,
});

export const OfferCallUsClickedEvent = (
  merchantId,
  offerId,
  seasonCampaignId,
) => ({
  type: 'OFFER_CALL_US_CLICKED',
  merchantId,
  offerId,
  seasonCampaignId,
});
// seasonCampaign navEvents
export const SeasonCampaignLandingPageClicked = (
  clusterId,
  seasonCampaignId,
) => ({
  type: 'SEASON_CAMPAIGN_LANDING_PAGE_CLICKED',
  clusterId,
  seasonCampaignId,
});

export const SeasonCampaignMerchantPageClicked = (
  clusterId,
  seasonCampaignId,
) => ({
  type: 'SEASON_CAMPAIGN_MERCHANT_PAGE_CLICKED',
  clusterId,
  seasonCampaignId,
});

export const ClusterGiftCollectionSelected = (clusterId, giftCollectionId) => ({
  type: 'CLUSTER_GIFT_COLLECTION_SELECTED',
  clusterId,
  giftCollectionId,
});

export const ClusterGiftOptionSelected = (
  clusterId,
  giftCollectionId,
  giftOptionId,
) => ({
  type: 'CLUSTER_GIFT_OPTION_SELECTED',
  clusterId,
  giftCollectionId,
  giftOptionId,
});

export const ClusterGiftOptionSelectFailed = (
  clusterId,
  giftCollectionId,
  giftOptionId,
) => ({
  type: 'CLUSTER_GIFT_OPTION_SELECT_FAILED',
  clusterId,
  giftCollectionId,
  giftOptionId,
});
